var app = angular.module("leonardo");

var WorkOrderDetailsDialog = function($scope, AttachmentService) {
  $scope.attachmentService = AttachmentService;
  $scope.workOrder = $scope.ngDialogData.work_order;
  $scope.validData = ['Portfolio', 'Property', 'Unit', 'Workflow', 'Action Item', 'Dynamic Form', 'Completed By', 'Completed Date'];
  $scope.validDataField = ['Question', 'Answer'];
};

app.controller('WorkOrderDetailsDialog', ['$scope', 'AttachmentService', WorkOrderDetailsDialog]);
